import { render, staticRenderFns } from "./TrafficStatistics.vue?vue&type=template&id=6e3f507e&scoped=true&"
import script from "./TrafficStatistics.vue?vue&type=script&lang=js&"
export * from "./TrafficStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TrafficStatistics.vue?vue&type=style&index=0&id=6e3f507e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f507e",
  null
  
)

export default component.exports